import React, {Dispatch, SetStateAction} from 'react';
import {INIT_COORDS, MAP_VIEW} from '../../core/constants/map.constants';
import {MessageKeys} from '../../core/constants/map.enums';
import {Map} from '../../core/map/map';

export interface MapCtx {
    map?: Map,
    ready: boolean,
    init: (element: HTMLElement) => Promise<Map | undefined>,
    geolocationGranted: boolean,
    warningLocationVisibility: MessageKeys,
    goToCurrentLocation: () => Promise<void>,
    currentLocation: google.maps.LatLngLiteral,
    setView: Dispatch<SetStateAction<MAP_VIEW>>,
    pointer: google.maps.LatLngLiteral,
    getNearMarkersData: any,
    createMarker: any,
    getCurrentPositionCoords: () => Promise<void>,
    deleteLocationMarker: any,
    centerMapToCoordenates: any,
    drawZbe: () => void,
    removeZbe: () => void,
    isNoParkingActive: boolean;
    activateNoParkingLayer: () => void;
    deactivateNoParkingLayer: () => void;
    setIsNoParkingActive: Dispatch<SetStateAction<boolean>>;
    setNoParkingActive: Dispatch<SetStateAction<boolean>>;
    setTransportListActivatedOnce: Dispatch<SetStateAction<boolean>>;
    noParkingActive: boolean;
    transportListActivatedOnce: boolean;
}

export const MapContext = React.createContext<MapCtx>(
    {
        ready: false,
        init: () => new Promise(Promise.resolve),
        geolocationGranted: false,
        warningLocationVisibility: MessageKeys.NONE,
        goToCurrentLocation: () => new Promise(Promise.resolve),
        currentLocation: INIT_COORDS,
        setView: () => {
        },
        pointer: INIT_COORDS,
        getNearMarkersData: (latitude: number, longitude: number, stopType: string):Array<any> => {
            return [];
        },
        createMarker: (coords: {}, type: string, infoWindowContent?: {}, redirect?: false, markerInfo?: any) =>{},
        getCurrentPositionCoords: () => {
            return new Promise((resolve, reject) => {});
        },
        deleteLocationMarker: () => {},
        centerMapToCoordenates: (latitude: number, longitude:number) => {},
        drawZbe: () => {},
        removeZbe: () => {},
        isNoParkingActive: false,
        activateNoParkingLayer: () => {},
        deactivateNoParkingLayer: () => {},
        setIsNoParkingActive: () => {},
        setNoParkingActive: () => {},
        setTransportListActivatedOnce: () => {},
        noParkingActive: false,
        transportListActivatedOnce: false,
    },
);

export const MapProvider = MapContext.Provider;
